import axios from "axios";
import { APP_VERSION } from "constants/variables";

// Utils
import { setCredentials } from "utils/credential";
import { setHostname } from "utils/hostname";

export const api = axios.create({
  baseURL: setHostname(),
  headers: {
    "Content-type": "application/json",
    "f-v": APP_VERSION,
  },
  withCredentials: setCredentials(),
});
